import { ALIGNMENTS } from '../blocks/constants';
export function centerablesInSelection(state) {
  let centerableNodes = [];
  state.doc.nodesBetween(state.selection.from, state.selection.to, function (node, pos, parent, _index) {
    if (node.attrs.alignment && parent && parent.type !== state.schema.nodes.listItem) {
      centerableNodes.push({
        pos,
        node
      });
    }
  });
  return centerableNodes;
}
export function dominantAlignment(centerables) {
  let alignmentCounts = {
    [ALIGNMENTS.left]: 0,
    [ALIGNMENTS.center]: 0,
    [ALIGNMENTS.right]: 0
  };
  centerables.forEach(centerable => {
    alignmentCounts[centerable.node.attrs.alignment] += 1;
  });
  let alignmentWithMaxValue = Object.keys(alignmentCounts).reduce((a, b) => alignmentCounts[a] >= alignmentCounts[b] ? a : b);
  return alignmentWithMaxValue;
}